
import {
  defineComponent,
  ref,
  computed,
  PropType,
  reactive,
} from 'vue';
import { updateKey } from '@/api/monitor-center';
import type { IUpdateKey, IKeysPageListItem } from '@/api/monitor-center/type.d';
import { ElMessage } from 'element-plus';
import KeyTips from './key-tips.vue';

export default defineComponent({
  name: 'UpdateKey',
  components: {
    KeyTips,
  },
  emits: ['update:visible', 'handleOperateSuccess'],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object as PropType<IKeysPageListItem>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const selfVisible = computed({
      get() {
        return props.visible;
      },
      set(val: boolean) {
        emit('update:visible', val);
      },
    });

    const formRef = ref();

    const formData = reactive<IUpdateKey>({
      oldKey: '',
      newKey: '',
    });

    const handleClose = () => {
      selfVisible.value = false;
      formRef.value.resetFields();
    };

    const handleSave = async () => {
      await formRef.value.validate();
      await updateKey(formData);
      ElMessage.success('操作成功！');
      emit('handleOperateSuccess', {
        key: formData.newKey,
      });
      handleClose();
    };

    const handleOpen = () => {
      formData.oldKey = props.data.key;
      formData.newKey = props.data.key;
    };

    return {
      formRef,
      formData,
      selfVisible,
      rules: {
        newKey: [
          { required: true, message: '请输入key', trigger: 'blur' },
        ],
      },
      handleClose,
      handleSave,
      handleOpen,
    };
  },
});
